import { Divider, Grid } from "@mui/material";
import React, { useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import { IRoleMain, MasterPages } from "../../../commonFunctions/CommonFunctions";
import { Header } from "../../../Components/Header/Header";
import WSImageView from "../../../Components/Image/WSImageView";
// import fullImage1 from '../../../FrontEnd/Images/Banner/1.jpg'
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../../StateManagement/actions";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";

export const BannerImageList: React.FC<any> = React.memo((props) => {
    const navigate = useNavigate();
    const { edit } = getPermissions(MasterPages.Users, IRoleMain.Masters);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const dispatch = useDispatch();
    const { showMessage } = useSnackbar();
    const source = {
        url: "banners/search",
        page: 1,
        pageSize: 10,
        filter: [
        //     {
        //     field: "IsDeleted",
        //     operator: "eq",
        //     value: "false"
        // }
    ],
        sort: [],
    };

    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`/banner/${row?._id}`)
        }
        if (action === 'Delete') {
            setSelectedId(row._id); // Set the ID of the row to be deleted
            setPopupOpen(true)
        }
    };
    const columns: IColumns[] = [
    
        {
            header: "Image",
            fieldName: "imageUrl",
            tooltip: true,
            type: "img",
        },
        {
            header: "Start Date",
            fieldName: "startDate",
            type: "date",
        },
        {
            header: "End Date",
            fieldName: "endDate",
            type: "date",
        },
        {
            header: "Display Order",
            fieldName: "displayOrder",
            type: "default",
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: ["Edit", 'Delete'],
            actionCallback: (action, row) => handleAction(action, row),
        },

    ];

    const handleClick = () => {
        navigate('/banner/create')
    }
    const handleDelete = (response: any) => {
        dispatch(resetDataComponent('bannerGrid'));
        showMessage('Banner deleted successfully!', 'success')
    };
    return (
        <>  <Grid item container spacing={2}>
            {/* <Grid item sm={12} xs={12}>
                <WSImageView imgUrl={fullImage1} isAnimated={false} imageSx={{ height: 300 }} />
            </Grid> */}
            <Grid item sm={12} xs={12}>
                <Divider />
            </Grid>
        </Grid>
            <Header type="simple" isDivider={true} title="Banners" id={'bannerImg'} headerSx={{ marginTop: 0 }} />
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <WSDataGrid
                        id="bannerGrid"
                        title="Banner"
                        columns={columns}
                        source={source}
                        addButton={{ label: 'New', color: 'secondary', }}
                        onAddButtonClick={handleClick}
                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />
                    {selectedId !== null && <ConfirmationPopup
                        apiUrl={'banners/delete'}
                        id={selectedId}
                        confirmMessage="Are you sure you want to delete this item?"
                        open={isPopupOpen}
                        onClose={() => setPopupOpen(false)}
                        onConfirm={handleDelete}
                        permanent
                    />}
                </Grid>
            </Grid>
        </>
    )
})